import React from 'react'

import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {Brand} from '@vio/core/src/brand/types'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {StyledListItem} from '../commonStyles'

interface Props {
  brand: Brand
  link?: string
}
export const HowItWorks = ({brand, link}: Props) => {
  if (!link) return null

  return (
    <StyledListItem
      as="link"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      hasDivider
      prefix={<Icon name="Information" />}
      title={
        <Text variant="labelM">
          <FormattedMessageWrapper
            {...brand.messages.howItWorksMessage}
            values={{brandName: brand.name}}
          />
        </Text>
      }
      suffix={<Icon name="ChevronRight" hasMirror />}
    />
  )
}
